import $ from 'jquery';

const ACTIVE = 'active';

const mapSelect = () => {
  const select = $('.js-select-map');
  select.on('click', ev => {
    ev.preventDefault();
    const self = $(ev.target);
    select.removeClass(ACTIVE);
    self.addClass(ACTIVE);
    const map = $(self.attr('href'));
    if (map.length) {
      map.siblings().removeClass(ACTIVE);
      map.addClass(ACTIVE);
    }
    $(window).trigger('resize');
  });
};
export default mapSelect;



// WEBPACK FOOTER //
// ./src/scripts/modules/map-select.js